import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { ReactComponent as Sorted } from '../../../../assets/img/sort-arrows.svg';
import {
  fontCondensed,
  fontDisplay,
  fontUi,
  viewMoreLink,
} from '../../../../theme/typography';
import { themedSelectMenuCss } from '../../../../theme/selectStyles';

export const StyledPage = styled.div`
  width: 100%;
`;

export const StyledBackLink = styled(Link)`
  ${viewMoreLink};
  margin: 0 0 12px;
  font-size: 13px;
`;

export const StyledToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 16px;
  @media(max-width:1199px) {display:grid;grid-template-columns:minmax(0,1fr) auto;gap:10px; > h2 {grid-column:1;grid-row:1;} > a {grid-column:2;grid-row:1;} > div {grid-column:1 / -1;width:100%;}}
`;

export const StyledTitle = styled.h2`
  ${fontDisplay};
  margin: 0;
  font-size: 22px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.text};
`;

export const StyledTeamSelect = styled(Select)`
  ${fontUi};
  width: 220px;
  flex-shrink: 0;
  font-size: 13px;

  .react-select__control {
    min-height: 36px;
    background: ${({ theme }) => theme.card};
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: ${({theme})=>theme.controlRadius};
    box-shadow: none;
    color: ${({ theme }) => theme.text};
  }
  .react-select__control--is-focused {
    border-color: ${({ theme }) => theme.border};
  }
  .react-select__single-value,
  .react-select__input-container {
    color: ${({ theme }) => theme.text};
  }
  .react-select__placeholder {
    ${fontUi};
    font-weight: 500;
    color: ${({ theme }) => theme.textFaint};
  }
  .react-select__indicator-separator {
    display: none;
  }
  .react-select__indicator {
    padding: 0 8px;
    svg {
      fill: ${({ theme }) => theme.textFaint};
      width: 12px;
    }
  }
  .react-select__clear-indicator {
    padding: 0 4px;
  }
  .react-select__value-container {
    padding: 2px 8px;
  }
  ${themedSelectMenuCss}
`;

export const StyledCard = styled.div`
  overflow: auto;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  padding: 8px 16px 10px;
  @media(max-width:1199px) {padding:0;border:0;background:transparent;box-shadow:none;overflow:visible;}
  box-sizing: border-box;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const StyledTh = styled.th`
  ${fontUi};
  padding: 10px 8px;
  text-align: ${({ $numeric }) => ($numeric ? 'center' : 'left')};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.textFaint};
  white-space: nowrap;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: ${({ theme }) => theme.text};
  }
`;

export const StyledSorted = styled(Sorted)`
  margin-left: 4px;
  width: 10px;
  height: 12px;
  vertical-align: -1px;
  fill: ${({ theme }) => theme.textFaint};
  ${({ $dir }) =>
    $dir === 'asc'
      ? `
    path:first-of-type { display: none; }
  `
      : $dir === 'desc'
        ? `
    path:last-of-type { display: none; }
  `
        : ''}
`;

export const StyledTd = styled.td`
  ${({ $numeric }) => ($numeric ? fontDisplay : fontUi)};
  padding: 10px 8px;
  border-top: 1px solid ${({ theme }) => theme.borderSubtle};
  font-size: 13px;
  color: ${({ theme }) => theme.text};
  text-align: ${({ $numeric }) => ($numeric ? 'center' : 'left')};
  font-variant-numeric: tabular-nums;
`;

export const StyledTr = styled.tr`
  cursor: pointer;

  &:hover ${StyledTd} {
    background: ${({ theme }) => theme.hover};
  }
`;

export const StyledPlayer = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    flex-shrink: 0;
  }

  strong {
    ${fontCondensed};
    font-weight: 400;
    letter-spacing: -0.02em;
  }
`;

export const StyledEmpty = styled.p`
  ${fontUi};
  margin: 0;
  padding: 24px 8px;
  text-align: center;
  color: ${({ theme }) => theme.textFaint};
  font-size: 13px;
`;

export const StyledExport = styled.a`
 ${fontUi};display:inline-flex;align-items:center;justify-content:center;gap:8px;min-height:36px;box-sizing:border-box;margin:0;padding:8px 12px;font-size:12px;font-weight:600;text-decoration:none;white-space:nowrap;cursor:pointer;
 color:${({theme})=>theme.text};background:${({theme})=>theme.card};border:1px solid ${({theme})=>theme.border};border-radius:${({theme})=>theme.controlRadius};
 svg {width:16px;height:16px;} svg path {fill:currentColor;}
 &:hover {background:${({theme})=>theme.hover};}
 &:focus-visible {outline:2px solid ${({theme})=>theme.headerAccent};outline-offset:3px;}
`;
export const StyledMobileList = styled.div`display:flex;flex-direction:column;gap:8px;`;
export const StyledScorerCard = styled.button`
 ${fontUi};width:100%;padding:0;text-align:left;overflow:hidden;cursor:pointer;border:1px solid ${({theme})=>theme.border};border-radius:${({theme})=>theme.cardRadius};background:${({theme})=>theme.card};color:${({theme})=>theme.text};
 .identity {display:flex;align-items:center;gap:10px;padding:10px 12px;background:${({theme})=>theme.hover};border-bottom:1px solid ${({theme})=>theme.borderSubtle};}
 .rank {font-size:12px;color:${({theme})=>theme.textFaint};font-variant-numeric:tabular-nums;min-width:20px;}
 img {width:28px;height:28px;object-fit:contain;flex-shrink:0;}
 .player {display:flex;flex-direction:column;gap:3px;min-width:0;flex:1;}
 .player strong {${fontCondensed};font-size:15px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
 .player > span {font-size:11px;color:${({theme})=>theme.textFaint};overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
 .position {font-size:11px;color:${({theme})=>theme.textMuted};}
 .stats {display:grid;grid-template-columns:repeat(4,minmax(0,1fr));padding:9px 12px;gap:8px;}
 .stats > span {display:flex;flex-direction:column;align-items:center;gap:2px;}
 .stats strong {font-size:14px;font-weight:600;font-variant-numeric:tabular-nums;}
 .stats small {font-size:9px;text-transform:uppercase;letter-spacing:.04em;color:${({theme})=>theme.textFaint};}
 &:hover {border-color:${({theme})=>theme.headerAccent};}
 &:focus-visible {outline:2px solid ${({theme})=>theme.headerAccent};outline-offset:2px;}
`;
